import { CircleCloseIcon } from 'assets/icons';
import { CustomPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';
import { FC, memo, useState } from 'react';
import { getSortedJobTags } from '../utils';
import { JobListItem } from '../jobs.model';
import TagPill from 'containers/tags/create-tag/Tag';

interface MoreTagsPopoverProps {
  job: JobListItem;
  visibleCount?: number;
}

const MoreTagsPopover: FC<MoreTagsPopoverProps> = memo(({ job, visibleCount = 2 }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenPopover = () => {
    setIsOpen(true);
  };

  const handleClosePopover = () => {
    setIsOpen(false);
  };

  const handleTogglePopover = () => {
    setIsOpen(!isOpen);
  };

  const sortedTags = getSortedJobTags(job.jobTags);
  const remainingCount = sortedTags.length - visibleCount;

  if (remainingCount <= 0) {
    return null;
  }

  return (
    <CustomPopover
      show={isOpen}
      offset="left-1/2 transform -translate-x-1/2"
      showArrow={true}
      arrowType={PopoverArrowTypes.TOP}
      arrowOffset="left-1/2 transform -translate-x-1/2"
      onTogglePopover={handleTogglePopover}
      onClosePopover={handleClosePopover}
      padding="p-0"
      containerClassName="cursor-default"
      anchorComponent={() => (
        <div className="cursor-pointer text-[13px] font-semibold text-secondary" onClick={handleOpenPopover}>
          {`+${remainingCount} more`}
        </div>
      )}>
      <div className="flex flex-col gap-2 p-3" onClick={e => e.stopPropagation()}>
        <div className="flex flex-row items-center justify-between">
          <p className="text-sbase font-bold text-primaryText">Tags</p>
          <CircleCloseIcon className="scale-75 cursor-pointer" onClick={handleClosePopover} />
        </div>
        <div className="h-[1px] w-full bg-borderGray" />
        <div className="flex max-h-44 w-[calc(100%+12px)] flex-col gap-2 overflow-y-auto pr-3">
          {sortedTags.slice(visibleCount).map((tag, index) => (
            <TagPill
              key={tag.id}
              tag={tag}
              className="w-fit px-2 py-1"
              textStyle="text-[13px] font-normal"
              id={`tag-${index + 1}`}
            />
          ))}
        </div>
      </div>
    </CustomPopover>
  );
});
export default MoreTagsPopover;
